module.exports = __webpack_public_path__ + "media/images/photos/australia-4e9c92a7d51aba0ef15e86b6e807456b.jpg";